module.exports = __webpack_public_path__ + "static/media/1.791ab279.JPG";